import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import redial from 'redial'
import { setStatus } from '../../status/statusActions'
import {
  changeActiveList,
  fetchCategoryItems,
  fetchCategoryItemsBatch,
  fetchCategoryItemsNext,
  unqueueCategoryItems,
  LIST_TYPE_CATEGORY,
  LIST_TYPE_NONE,
  LIST_NAME_NONE,
} from '../../components/item/itemsActions'
import CategoryItemsEmpty from './CategoryItemsEmpty'
import TopNotification from '../../user/TopNotification'
import {
  selectIsUserLoggedIn,
  selectUserBlacklistedCategoryIds,
  selectUserWhitelistedCategoryIds,
} from '../../selectors/userSelector'
import NewsListWidgets from '../../components/lists/NewsListWidgets'
import { selectCategoryBySlug } from '../../selectors/categoriesSelector'
import ListOptions from '../../components/ui/ListOptions'
import { fetchPopular } from '../../components/item/popularActions'
import NewsListView from './NewsListView'
import { CATEGORY_ID_UUTISET } from '../../lib/constants'

@redial.provideHooks({
  fetch: ({ dispatch, getState, params: { category } }) => {
    const state = getState()
    const catRecord = selectCategoryBySlug(state, category)
    if (!catRecord) {
      return dispatch(setStatus(404))
    }

    dispatch(changeActiveList(LIST_TYPE_CATEGORY, category))
    return Promise.all([
      dispatch(fetchPopular(300, { categoryId: catRecord.id })),
      dispatch(fetchCategoryItems(category)),
    ])
  },
})
export class CategoryView extends Component {
  constructor(props) {
    super(props)
    this.setActiveList = this.setActiveList.bind(this)
  }

  static propTypes = { // eslint-disable-line react/prefer-exact-props
    category: ImmutablePropTypes.recordOf({
      id: PropTypes.number.isRequired,
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      parentId: PropTypes.number.isRequired,
      treeLevel: PropTypes.number.isRequired,
      desc: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      h1: PropTypes.string.isRequired,
      relatedCategoryIds: ImmutablePropTypes.orderedSet,
      ogTitle: PropTypes.string,
      ogDesc: PropTypes.string,
      ogImage: PropTypes.string,
    }).isRequired,
    itemsForCategory: ImmutablePropTypes.map,
    dispatch: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired,
    listBlacklisted: PropTypes.bool.isRequired,
    listWhitelisted: PropTypes.bool.isRequired,
    trendingFailedToLoad: PropTypes.bool,
    trending: ImmutablePropTypes.map,
    params: PropTypes.shape({
      category: PropTypes.string.isRequired,
    }).isRequired,
  }

  handleListDidUpdate(prevProps, props) {
    const { dispatch, category } = props

    if (prevProps.category !== category) {
      dispatch(changeActiveList(LIST_TYPE_CATEGORY, category.get('slug')))
    }
  }

  setActiveList() {
    const { dispatch, category } = this.props

    dispatch(changeActiveList(LIST_TYPE_CATEGORY, category.get('slug')))
  }

  refreshList = () => {
    const { dispatch, params: { category } } = this.props
    dispatch(fetchCategoryItems(category))
  }

  fetchNext = (timestamp) => {
    const { dispatch, params: { category } } = this.props
    dispatch(fetchCategoryItemsNext(category, timestamp))
  }

  handleFetchBatchItems = (batch) => {
    const { dispatch, category } = this.props
    dispatch(fetchCategoryItemsBatch(category.slug, batch))
  }

  unqueueItems = () => {
    const { dispatch, params: { category } } = this.props
    dispatch(unqueueCategoryItems(category))
  }

  getTitle() {
    const { category } = this.props

    return category ? category.get('title') + ' | Tuoreimmat uutiset | Ampparit.com' : ''
  }

  getH1() {
    const { category } = this.props

    if (category) {
      return category.get('id') === CATEGORY_ID_UUTISET ? category.get('h1') : `${category.get('h1')} | Uutiset`
    }

    return ''
  }

  getOgTitle() {
    const { category } = this.props

    return category?.get('ogTitle')
  }

  getMetaDescription() {
    const { category } = this.props

    return category?.get('desc')
  }

  getOgDescription() {
    const { category } = this.props

    return category?.get('ogDesc')
  }

  getOgImage() {
    const { category } = this.props

    return category?.get('ogImage')
  }

  componentWillUnmount() {
    this.props.dispatch(changeActiveList(LIST_TYPE_NONE, LIST_NAME_NONE))
  }

  renderFailedToLoad = () => (
    <TopNotification>
      <p><b>Uutisten lataaminen epäonnistui.</b></p>
    </TopNotification>
  )

  renderBlacklistedNotification = () => (
    <TopNotification>
      <p><b>Olet piilottanut tämän kategorian.</b></p>
    </TopNotification>
  )

  renderListOptions = () => {
    const { category, dispatch, listWhitelisted, listBlacklisted } = this.props
    return (
      <ListOptions
        tag={ category }
        isCategory={ true }
        dispatch={ dispatch }
        whitelisted={ listWhitelisted }
        blacklisted={ listBlacklisted }
      />
    )
  }

  renderEmpty = () => <CategoryItemsEmpty category={ this.props.category } />

  renderNewsListWidgets = () => <NewsListWidgets category={ this.props.category } />

  render() {
    const { itemsForCategory, category, listBlacklisted, trendingFailedToLoad, trending, path } = this.props

    return (
      <NewsListView
        getListTitle={ this.getTitle() }
        getListH1={ this.getH1() }
        getListOgTitle={ this.getOgTitle() }
        getListMetaDescription={ this.getMetaDescription() }
        getListOgDescription={ this.getOgDescription() }
        getListOgImage={ this.getOgImage() }
        list={ itemsForCategory }
        loading={ false }
        listBlacklisted={ listBlacklisted }
        trendingFailedToLoad={ trendingFailedToLoad }
        trending={ trending }
        renderBlacklistedNotification={ this.renderBlacklistedNotification }
        renderListOptions={ this.renderListOptions }
        renderEmpty={ this.renderEmpty }
        renderNewsListWidgets={ this.renderNewsListWidgets }
        onFetchBatchItems={ this.handleFetchBatchItems }
        handleFetchNext={ this.fetchNext }
        category={ category }
        tag={ null }
        path={ path }
        refreshList={ this.refreshList }
        unqueueItems={ this.unqueueItems }
        renderFailedToLoad={ this.renderFailedToLoad }
        onListDidUpdate={ this.handleListDidUpdate }
        setActiveList={ this.setActiveList }
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { trending } = state

  const categorySlug = ownProps.params.category
  const itemsForCategory = state.items.categories.get(categorySlug)

  const category = selectCategoryBySlug(state, categorySlug)
  const isBlacklisted = category != null && selectUserBlacklistedCategoryIds(state).contains(category.id)
  const isWhitelisted = category != null && selectUserWhitelistedCategoryIds(state).contains(category.id)

  return {
    itemsForCategory,
    category,
    listBlacklisted: isBlacklisted,
    listWhitelisted: isWhitelisted,
    loggedIn: selectIsUserLoggedIn(state),
    trendingFailedToLoad: trending.get('failedToLoad'),
    trending: trending,
  }
}

export default connect(mapStateToProps)(CategoryView)
